import { Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
  iconOnly?: boolean
  className?: string
}

export function Logo({ size = 'md', showText = true, iconOnly = false, className }: LogoProps) {
  const sizeClasses = {
    sm: {
      container: 'space-x-2',
      icon: 'w-6 h-6',
      iconSize: 'w-4 h-4',
      text: 'text-lg',
    },
    md: {
      container: 'space-x-3',
      icon: 'w-8 h-8',
      iconSize: 'w-5 h-5',
      text: 'text-xl',
    },
    lg: {
      container: 'space-x-4',
      icon: 'w-10 h-10',
      iconSize: 'w-6 h-6',
      text: 'text-2xl',
    },
  }

  const sizes = sizeClasses[size]

  if (iconOnly) {
    return (
      <div
        className={cn(
          'bg-primary rounded-lg flex items-center justify-center flex-shrink-0',
          sizes.icon,
          className
        )}
      >
        <Sparkles className={cn('text-primary-foreground', sizes.iconSize)} />
      </div>
    )
  }

  return (
    <div className={cn('flex items-center', sizes.container, className)}>
      <div
        className={cn(
          'bg-primary rounded-lg flex items-center justify-center flex-shrink-0',
          sizes.icon
        )}
      >
        <Sparkles className={cn('text-primary-foreground', sizes.iconSize)} />
      </div>
      {showText && <span className={cn('font-bold', sizes.text)}>OpenArtifacts</span>}
    </div>
  )
}
